// Mock data for Mega Draw Challenge

export const campaignData = {
  name: "Mega Draw Challenge",
  startDate: "2025-12-10",
  endDate: "2025-12-28",
  totalPrizePool: 2025,
  currency: "USD"
};

export const prizes = [
  { position: "1st", amount: 600, label: "Grand Prize" },
  { position: "2nd", amount: 400, label: "Second Prize" },
  { position: "3rd", amount: 300, label: "Third Prize" },
  { position: "4th-5th", amount: 175, label: "Fourth & Fifth Prize", perWinner: true },
  { position: "6th-10th", amount: 75, label: "Sixth to Tenth Prize", perWinner: true }
];

export const ticketHolders = [
  { name: "Ahmad Trader", tickets: 156 },
  { name: "Sarah FX", tickets: 142 },
  { name: "Mike Gold", tickets: 128 },
  { name: "Lisa Crypto", tickets: 115 },
  { name: "John Swift", tickets: 98 },
  { name: "Emma Charts", tickets: 87 },
  { name: "David Pips", tickets: 76 },
  { name: "Nina Forex", tickets: 65 },
  { name: "Chris Wave", tickets: 54 },
  { name: "Anna Trade", tickets: 48 },
  { name: "Tom Bull", tickets: 42 },
  { name: "Kate Bear", tickets: 38 },
  { name: "James Flow", tickets: 35 },
  { name: "Lucy Trend", tickets: 32 },
  { name: "Mark Candle", tickets: 28 },
  { name: "Sophie RSI", tickets: 25 },
  { name: "Alex MACD", tickets: 22 },
  { name: "Grace Swing", tickets: 19 },
  { name: "Ben Scalp", tickets: 16 },
  { name: "Zoe Long", tickets: 14 }
];

export const motivationalQuotes = [
  "More tickets mean more chances.",
  "Consistency builds probability.",
  "Every trade strengthens your position."
];

export const ctaLink = "https://t.me/firaindicator/23341";
